import { createI18n } from 'vue-i18n'
import enUS from './languages/en_US.json'
import svSE from './languages/sv_SE.json'

export const supportedLocales = ['en-US', 'sv-SE'] as const
export type SupportedLocale = (typeof supportedLocales)[number]

function detectDeviceLocale(): SupportedLocale {
  const deviceLang = navigator.language // e.g. "sv-SE", "en-US", "en", "sv"
  const exact = supportedLocales.find((l) => l === deviceLang)
  if (exact) return exact
  // Match by language code prefix (e.g. "en" matches "en-US", "sv" matches "sv-SE")
  const prefix = deviceLang.split('-')[0]
  const partial = supportedLocales.find((l) => l.startsWith(prefix + '-'))
  return partial ?? 'sv-SE'
}

export const defaultLocale = detectDeviceLocale()

const i18n = createI18n({
    legacy: false,
    locale: defaultLocale,
    supportedLocales: [...supportedLocales],
    globalInjection: true,
    messages: {
        'en-US': enUS,
        'sv-SE': svSE
    }
})

export { i18n }
